import { useLogiConfig, useLogiReportsTranslation } from '../../../../ui/hooks';
import { ColorPaper } from '@juvare/common-web-ui/ColorPaper';
import { PageError } from '@juvare/common-web-ui/PageError';
import { LogiVisualBuilder } from '@juvare/logi-library';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
export const EditVisual = () => {
    const { t } = useLogiReportsTranslation();
    const { visualId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { data, isLoading, error } = useLogiConfig();
    if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    if (error) {
        return React.createElement(PageError, { error: error });
    }
    if (!data) {
        return React.createElement(PageError, { message: t('common.error') });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ColorPaper, { gradient: 'blue-base', sx: { px: 4, pt: 2, pb: 3, display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'start' } },
            React.createElement(Button, { variant: 'text', color: 'inherit', startIcon: React.createElement(ArrowBackIcon, null), onClick: () => {
                    var _a;
                    if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.back) {
                        navigate(-1);
                    }
                    else {
                        navigate('/');
                    }
                } }, t('panels.visuals.returnToVisuals')),
            React.createElement(Typography, { variant: 'h1' }, location.state.visualName)),
        visualId && (React.createElement(LogiVisualBuilder, { configuration: Object.assign(Object.assign({}, data.componentConfig), { visualId: visualId }), getToken: data.getToken, logiBaseUrl: data.logiBaseUrl }))));
};
